export const SDK_VERSION = '6.5.1';
